import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-wrong-language-dialog',
    templateUrl: './wrong-language-dialog.html'
})
export class WrongLanguageDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<WrongLanguageDialogComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/wrong-language-dialog/wrong-language-dialog.ts